import { useRef, useState } from "react";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import ServiceEnquiry from "../../services/servicesEnquiry";

const PackagingEnquiryForm = ({ handleClose }) => {
  const [, setForceUpdate] = useState("");
  const [loader, setLoader] = useState(false);

  const [inputValue, setInputValue] = useState({
    name: "",
    phone: "",
    email: "",
    description: "",
    value_of_goods: "",
    weight: "",
    special_request: "",
  });

  const handleChange = (event) => {
    setInputValue({ ...inputValue, [event.target.name]: event.target.value });
  };
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
      messages: {
        required: "Required",
      },
    })
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    // setLoader(true)
    let validate = null;

    if (inputValue) {
      validate = validator.current.allValid();
      if (validate) {
        setLoader(true);
        ServiceEnquiry.packingEnquiry(inputValue)
          .then((res) => {
            setLoader(false);
            if (res.status === true) {
              toast.success(res.message);
              handleClose();
              setInputValue({});
            } else {
              toast.error(res.message);
            }
          })
          .catch((error) => {
            setLoader(false);
            console.log(error);
          });
      } else {
        setLoader(false);
        validator.current.showMessages();
      }
    }
  };

  return (
    <div className="container p-4">
      <div className="row ">
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="row">
            {/* Name */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Customer Name<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="text"
                min="1"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="name"
                placeholder="Enter Name"
                value={inputValue.name}
              />
              {validator.current.message("Name", inputValue?.name, "required", {
                className: "text-danger",
              })}
            </div>

            {/* Phone */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Phone No.<span className="text-danger">*</span>
              </label>
              <input
                onChange={(e) => {
                  handleChange(e);
                }}
                className="form-control p-3"
                type="number"
                min="1"
                name="phone"
                placeholder="Enter Phone No."
                value={inputValue.phone}
              />
              {validator.current.message(
                "Mobile",
                inputValue?.phone,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>

            {/* Email */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Email<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="email"
                onChange={(e) => {
                  handleChange(e);
                }}
                min="1"
                name="email"
                placeholder="Enter Email"
                value={inputValue.email}
              />
              {validator.current.message(
                "Email",
                inputValue?.email,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>

            {/* Cargo Description */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Goods Description<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="text"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="description"
                placeholder="Enter Description"
                value={inputValue.description}
              />
              {validator.current.message(
                "Description",
                inputValue?.description,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>
            {/* Value of Goods */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Value of Goods<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="number"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="value_of_goods"
                placeholder="Enter Value of Goods"
                value={inputValue.value_of_goods}
              />
              {validator.current.message(
                "Value of Goods",
                inputValue?.value_of_goods,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>

            {/*  Weight */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Total Weight (KGS)<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="number"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="weight"
                placeholder="Enter Weight"
                value={inputValue.weight}
              />
              {validator.current.message(
                "Weight",
                inputValue?.weight,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>

            {/* Special Request */}
            <div className="mb-3 col-md-12 position-relative">
              <label className="form-label mb-0">Special Request</label>
              <input
                className="form-control p-3"
                type="text"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="special_request"
                placeholder="Enter Special Request"
                value={inputValue.special_request}
              />
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={handleClose}
              className="btn getquoteBtn cancel mb-3 mx-2"
              style={{ padding: " 27px 56px" }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn getquoteBtn mb-3 mx-2"
              style={{ padding: " 27px 56px" }}
            >
              {(loader && (
                <div class="spinner-grow text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              )) ||
                "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PackagingEnquiryForm;
